import React from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape,
} from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { bindActionCreators } from 'redux';
import { withCookies, Cookies } from 'react-cookie';
import NoSsr from '@material-ui/core/NoSsr';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import SaveIcon from '@material-ui/icons/Save';
import RemoveIcon from '@material-ui/icons/Delete';
import PrintIcon from '@material-ui/icons/Print';
import SyncIcon from '@material-ui/icons/Sync';
import Snackbar from '@material-ui/core/Snackbar';
import ShareIcon from '@material-ui/icons/Share';
import VismaSign from '../../components/statelessComponents/Icons/VismaSign';
import RestrictedAccessModal from '../../components/RestrictedAccessModal/RestrictedAccessModal';
import AddVismaSIgnModal from '../../components/AddVismaSignModal/AddVismaSIgnModal';
import {
  isAdmin,
  isAllowedToTeacherCreateBundleCert,
  isTrial,
} from '../../helpers';
import * as certActions from '../../actions/cert';
import s from './Cert.scss';
import PdfViewer from '../../components/PdfViewer/PdfViewer';
import CustomModal from '../../components/Modals/Modal';
import VISMA_DOC_STATUSES from '../../constants/vismaDocStatuses';
import SignatureStatus from './SignatureStatus/SignatureStatus';
import BundleCertDetails from '../../components/BundleCertDetails/BundleCertDetails';
import { ViewIcon } from '../../components/statelessComponents/Icons';
import history from '../../history';
import ConfirmDeleteDialog from '../../components/statelessComponents/ConfirmDeleteDialog';
import ShareCertificateModal from '../../components/ShareCertificateModal/ShareCertificateModal';

const messages = defineMessages({
  download: {
    id: 'Cert.download',
    defaultMessage: 'Download',
    description: 'Download button text',
  },
  print: {
    id: 'Cert.print',
    defaultMessage: 'Print',
    description: 'Print button text',
  },
  regenerate: {
    id: 'Cert.regenerate',
    defaultMessage: 'Regenerate',
  },
  certificateWillBeGeneratedSoon: {
    id: 'Cert.certificateWillBeGeneratedSoon',
    defaultMessage: 'Certificate image will be generated soon',
  },
  trial: {
    id: 'Cert.trial',
    defaultMessage: 'Trial account',
  },
  vismaSignTooltip: {
    id: 'Cert.vismaSignTooltip',
    defaultMessage: 'Add Visma digital signature',
  },
  vismaSignLabel: {
    id: 'Cert.vismaSignLabel',
    defaultMessage: 'Add Visma sign',
  },
  showDetailsLabel: {
    id: 'Cert.showDetailsLabel',
    defaultMessage: 'Show details',
  },
  showDetailsTooltip: {
    id: 'Cert.showDetailsTooltip',
    defaultMessage: 'Show certificate collection details',
  },
  confirmRemoveTitle: {
    id: 'Cert.confirmRemoveTitle',
    defaultMessage: 'This action is irreversible. Are you sure?',
  },
  removeCertificateBtnLabel: {
    id: 'General.removeTitle',
    defaultMessage: 'Remove',
  },
  removingDescription: {
    id: 'Cert.removingDescription',
    defaultMessage:
      'By confirming this, the certificate will be removed, and it will be impossible to restore it.',
  },
  removingDescriptionWithVismaWarn: {
    id: 'Cert.removingDescriptionWithVismaWarn',
    defaultMessage:
      'This certificates is related to Visma digital signature, by confirming this, the certificate will be removed, Visma sign invitation canceled, document removed from Visma service and it will be impossible to restore it.',
  },
  shareBtn: {
    id: 'Cert.share',
    defaultMessage: 'Share',
    description: 'Share button text',
  },
});

@injectIntl
@withCookies
@connect(
  state => ({
    auth: state.auth,
    loading: state.cert.loading,
    cert: state.cert.cert,
    user: state.editUser.user,
    locale: state.intl.locale,
  }),
  dispatch =>
    bindActionCreators(
      {
        ...certActions,
      },
      dispatch,
    ),
)
@withStyles(s)
export default class Cert extends React.Component {
  static propTypes = {
    cert: PropTypes.shape({
      _id: PropTypes.string,
      code: PropTypes.string,
      name: PropTypes.string,
      userId: PropTypes.string,
      courseId: PropTypes.string,
      examId: PropTypes.string,
      assignmentId: PropTypes.string,
      demonstrationId: PropTypes.string,
      certificateCollectionId: PropTypes.arrayOf(
        PropTypes.shape({
          code: PropTypes.string.isRequired,
          _id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          supervisorOrganization: PropTypes.string,
          supervisor: PropTypes.string,
          certificateFiles: PropTypes.arrayOf(
            PropTypes.shape({
              path: PropTypes.string,
            }),
          ),
        }),
      ),
    }).isRequired,
    auth: PropTypes.shape({}).isRequired,
    user: PropTypes.shape({}).isRequired,
    loading: PropTypes.bool.isRequired,
    getCert: PropTypes.func.isRequired,
    setCert: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    locale: PropTypes.string.isRequired,
  };

  static contextTypes = {
    fetch: PropTypes.func,
    query: PropTypes.shape({
      print: PropTypes.string,
    }),
    cloudfrontUrl: PropTypes.string,
    apiUrl: PropTypes.string,
    cookiePrefix: PropTypes.string,
    initWs: PropTypes.func,
    organizationSlug: PropTypes.string,
  };

  state = {
    isRegenerating: false,
    isRestrictedAccessModalOpened: false,
    isAddVismaSignModalOpened: false,
    isBundleCertDetailsOpened: false,
    isConfirmDeleteOpen: false,
    isRemoving: false,
    removingErr: '',
    isShareModalOpened: false,
  };

  componentDidMount() {
    if (_.get(this, 'context.query.print') !== undefined) {
      setTimeout(() => {
        this.print();
      }, 500);
    }
    if (!_.get(this, 'props.cert.file')) {
      this.initWs();
    }
  }

  componentWillUnmount() {
    if (!this.ws) {
      return;
    }
    this.ws.off('certificate_image_generated');
  }

  onAddVismaSignModalSubmitted = () => {
    const { getCert, cert } = this.props;
    return getCert(cert.code);
  };

  print = () => {
    window.print();
  };

  initWs = () => {
    const { setCert, cert } = this.props;
    this.ws = this.context.initWs();

    this.ws.on('certificate_image_generated', certificate => {
      if (_.get(certificate, '_id') !== cert._id) {
        return;
      }
      setCert(certificate);
    });
  };

  regenerate = () => {
    const { cert, getCert } = this.props;

    this.setState({
      isRegenerating: true,
    });

    return this.context
      .fetch(`/api/certificates/${cert._id}/regenerate`, {
        method: 'PUT',
      })
      .then(res => {
        if (res.ok) {
          getCert(cert.code);
        }

        this.setState({
          isRegenerating: false,
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          isRegenerating: false,
        });
      });
  };

  removeBundleCertificate = async () => {
    const { cert } = this.props;
    const { organizationSlug } = this.context;

    this.setState({
      isRemoving: true,
    });

    try {
      const res = await this.context.fetch(`/api/certificates/${cert._id}`, {
        method: 'DELETE',
      });
      if (res.ok) {
        return history.push(
          `/${this.props.locale}${
            organizationSlug ? `/${organizationSlug}` : ''
          }/profiles/${cert.userId}`,
        );
      }

      const resJson = await res.json();
      return this.setState({
        isRemoving: false,
        removingErr: resJson.message,
      });
    } catch (err) {
      return this.setState(
        {
          isRemoving: false,
          removingErr: err.message,
        },
        this.hideConfirmDelete,
      );
    }
  };

  openRestrictedAccessModal = () => {
    this.setState({
      isRestrictedAccessModalOpened: true,
    });
  };

  closeRestrictedAccessModal = () => {
    this.setState({
      isRestrictedAccessModalOpened: false,
    });
  };

  openAddVismaSignModal = () => {
    this.setState({
      isAddVismaSignModalOpened: true,
    });
  };

  closeAddVismaSignModal = () => {
    this.setState({
      isAddVismaSignModalOpened: false,
    });
  };

  openBundleCertDetails = () => {
    this.setState({
      isBundleCertDetailsOpened: true,
    });
  };

  closeBundleCertDetails = () => {
    this.setState({
      isBundleCertDetailsOpened: false,
    });
  };

  handleCloseErrSnackbar = () => {
    this.setState({
      isConfirmDeleteOpen: false,
      isRemoving: false,
      removingErr: '',
    });
  };

  hideConfirmDelete = () => {
    this.setState({
      isConfirmDeleteOpen: false,
      isRemoving: false,
    });
  };

  openConfirmDelete = () => {
    this.setState({
      isConfirmDeleteOpen: true,
    });
  };

  openShareCertModal = () => {
    this.setState({
      isShareModalOpened: true,
    });
  };

  closeShareCertModal = () => {
    this.setState({
      isShareModalOpened: false,
    });
  };

  render() {
    const {
      cert,
      auth,
      loading,
      intl: { formatMessage },
      user,
    } = this.props;
    const {
      isRegenerating,
      isRestrictedAccessModalOpened,
      isAddVismaSignModalOpened,
      isBundleCertDetailsOpened,
      isRemoving,
      isConfirmDeleteOpen,
      removingErr,
      isShareModalOpened,
    } = this.state;
    const hasImage = !!_.get(cert, 'file.path');

    const isBundleCert = !!_.get(cert, 'certificateCollectionId');
    const isBundleCertSigned =
      _.get(cert, 'vismaSign.status') === VISMA_DOC_STATUSES.signed;
    const isAllowedToSignBundleCert =
      !isBundleCertSigned &&
      _.get(cert, 'vismaSign.status') !== VISMA_DOC_STATUSES.pending;

    const isDigitalSignatureActiveted = _.get(
      user,
      'mainGroup.certificateCollectionsAndDigitalSignature',
    );

    const isCertOwner = _.get(cert, 'userId') === _.get(auth, 'user._id');
    const isCertPublic = _.get(cert, 'isPublic', false);

    return (
      <div className={s.root}>
        <div className={s.container}>
          <Paper className={s.paper}>
            <div className={s.header}>
              <Typography variant="h4" component="h1">
                {cert.name}
              </Typography>
              {isAllowedToTeacherCreateBundleCert(auth, user) &&
                hasImage &&
                isBundleCert && <SignatureStatus cert={cert} />}
              <div className={s.actions}>
                {isDigitalSignatureActiveted &&
                  hasImage &&
                  isBundleCert &&
                  (isAllowedToTeacherCreateBundleCert(auth, user) ||
                    cert.userId === _.get(auth, 'user._id')) && (
                    <Tooltip title={formatMessage(messages.showDetailsTooltip)}>
                      <Button
                        data-test-id="T-Nn68QIyo2vTK2siAvA1"
                        variant="outlined"
                        color="primary"
                        className={classNames(s.btn, s.btnEnabled)}
                        onClick={this.openBundleCertDetails}
                      >
                        <ViewIcon className={s.buttonIcon} />
                        <FormattedMessage {...messages.showDetailsLabel} />
                      </Button>
                    </Tooltip>
                  )}
                {hasImage && (
                  <Tooltip title={formatMessage(messages.print)}>
                    <Button
                      data-test-id="OUWiAr2mEnckEiVvVfKmP"
                      variant="outlined"
                      color="primary"
                      className={classNames(s.btn, s.btnEnabled)}
                      onClick={
                        isTrial(auth)
                          ? this.openRestrictedAccessModal
                          : this.print
                      }
                    >
                      <PrintIcon className={s.buttonIcon} />
                      <FormattedMessage {...messages.print} />
                    </Button>
                  </Tooltip>
                )}
                {isAdmin(auth) &&
                  (cert.courseId ||
                    cert.examId ||
                    cert.assignmentId ||
                    cert.demonstrationId) && (
                    <div className={s.buttonWrapper}>
                      <Button
                        data-test-id="V0kTxwd7UcssZK_5GMttY"
                        variant="outlined"
                        color="primary"
                        className={s.btn}
                        onClick={this.regenerate}
                        disabled={isRegenerating || loading}
                      >
                        <SyncIcon className={s.buttonIcon} />
                        <FormattedMessage {...messages.regenerate} />
                        {(isRegenerating || loading) && (
                          <CircularProgress
                            size={24}
                            className={s.buttonProgress}
                          />
                        )}
                      </Button>
                    </div>
                  )}
                {isDigitalSignatureActiveted &&
                  isAllowedToTeacherCreateBundleCert(auth, user) &&
                  hasImage &&
                  isBundleCert &&
                  !_.get(cert, 'vismaSign.signDate') && (
                    <Tooltip
                      title={
                        isAllowedToSignBundleCert
                          ? formatMessage(messages.vismaSignTooltip)
                          : ''
                      }
                    >
                      <span>
                        <Button
                          data-test-id="CCLYtX9j1ZHQYGSCiYp2t"
                          variant="contained"
                          color="primary"
                          className={classNames(s.btn, s.btnEnabled)}
                          onClick={this.openAddVismaSignModal}
                          disabled={!isAllowedToSignBundleCert}
                        >
                          <VismaSign className={s.buttonIcon} />
                          <FormattedMessage {...messages.vismaSignLabel} />
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                {hasImage && (
                  <Tooltip title={formatMessage(messages.download)}>
                    <Button
                      data-test-id="HTptBmI-NSgGtSnzONBQr"
                      component={isTrial(auth) ? Button : 'a'}
                      href={`${this.context.apiUrl}/api/certificates/${cert._id}/download`}
                      onClick={
                        isTrial(auth)
                          ? event => {
                              event.preventDefault();
                              this.openRestrictedAccessModal();
                            }
                          : undefined
                      }
                      target="_blank"
                      color="primary"
                      variant="contained"
                      className={classNames(s.btn, s.btnEnabled)}
                    >
                      <SaveIcon className={s.buttonIcon} />
                      <FormattedMessage {...messages.download} />
                    </Button>
                  </Tooltip>
                )}
                {hasImage && isCertPublic && isCertOwner && (
                  <Tooltip title={formatMessage(messages.shareBtn)}>
                    <Button
                      data-test-id="oJr__M91iSn7Oo8YA0WtL"
                      onClick={this.openShareCertModal}
                      target="_blank"
                      color="primary"
                      variant="contained"
                      className={classNames(s.btn, s.btnEnabled)}
                    >
                      <ShareIcon className={s.buttonIcon} />
                      <FormattedMessage {...messages.shareBtn} />
                    </Button>
                  </Tooltip>
                )}
                {isAdmin(auth) && isBundleCert && (
                  <Tooltip
                    title={formatMessage(messages.removeCertificateBtnLabel)}
                  >
                    <Button
                      data-test-id="ziGvHp0GgDk1s4Ilnn4YZ"
                      variant="outlined"
                      color="secondary"
                      className={s.btn}
                      onClick={this.openConfirmDelete}
                      disabled={isRemoving || loading}
                    >
                      <RemoveIcon color="secondary" />
                      <FormattedMessage
                        {...messages.removeCertificateBtnLabel}
                      />

                      {isRemoving && (
                        <CircularProgress
                          size={24}
                          className={s.buttonProgress}
                        />
                      )}
                    </Button>
                  </Tooltip>
                )}
              </div>
            </div>
            <div id="print-cert" className={s.certWrapper}>
              {hasImage && isTrial(auth) && (
                <div className={s.red}>
                  <FormattedMessage {...messages.trial} />
                  <br />
                  <FormattedMessage {...messages.trial} />
                  <br />
                  <FormattedMessage {...messages.trial} />
                  <br />
                  <FormattedMessage {...messages.trial} />
                  <br />
                  <FormattedMessage {...messages.trial} />
                </div>
              )}
              {hasImage && isBundleCert && (
                <NoSsr>
                  <PdfViewer
                    fileUrl={`${this.context.cloudfrontUrl}/${_.get(
                      cert,
                      'pdfFile.path',
                      '',
                    )}`}
                    className={s.img}
                  />
                </NoSsr>
              )}
              {hasImage && !isBundleCert && (
                <img
                  src={`${this.context.cloudfrontUrl}/${_.get(
                    cert,
                    'file.path',
                    '',
                  )}`}
                  alt={_.get(cert, 'file.name', '')}
                  className={s.img}
                />
              )}
              {!hasImage && (
                <FormattedMessage
                  {...messages.certificateWillBeGeneratedSoon}
                />
              )}
            </div>
          </Paper>
          <Modal
            open={isRestrictedAccessModalOpened}
            onClose={this.closeRestrictedAccessModal}
          >
            <RestrictedAccessModal onClose={this.closeRestrictedAccessModal} />
          </Modal>
          <Modal open={isShareModalOpened} onClose={this.closeShareCertModal}>
            <ShareCertificateModal
              onClose={this.closeShareCertModal}
              certPage={`${this.props.locale}${
                this.context.organizationSlug
                  ? `/${this.context.organizationSlug}`
                  : ''
              }/cert/${cert.code}`}
              certId={cert._id}
            />
          </Modal>
          <CustomModal
            aria-describedby="add-visma-sign-modal"
            isOpen={isAddVismaSignModalOpened}
            width="45%"
          >
            <AddVismaSIgnModal
              onClose={this.closeAddVismaSignModal}
              onSubmit={this.onAddVismaSignModalSubmitted}
              cert={cert}
              submitRoute={`/api/certificates/${cert._id}/visma-sign?userId=${cert.userId}`}
            />
          </CustomModal>
          <BundleCertDetails
            isOpen={isBundleCertDetailsOpened && !!cert}
            files={cert?.certificateCollectionId?.certificateFiles}
            name={cert.name}
            certificates={cert?.certificateCollectionId?.certificatesIds}
            ariaDescribedBy="bundle-cert-details-modal"
            onClose={this.closeBundleCertDetails}
          />
          <ConfirmDeleteDialog
            isShown={isConfirmDeleteOpen}
            onClose={this.hideConfirmDelete}
            submit={this.removeBundleCertificate}
            isDeleting={isRemoving}
            deleteBtnId="confirm-remove-certificate"
            submitColor="primary"
            deleteBtnLabel={formatMessage(messages.removeCertificateBtnLabel)}
            title={<FormattedMessage {...messages.confirmRemoveTitle} />}
            description={
              <FormattedMessage
                {...(isBundleCertSigned ||
                _.get(cert, 'vismaSign.status') === VISMA_DOC_STATUSES.pending
                  ? messages.removingDescriptionWithVismaWarn
                  : messages.removingDescription)}
              />
            }
          />
          <Snackbar
            open={!!removingErr}
            onClose={this.handleCloseErrSnackbar}
            autoHideDuration={3000}
            message={removingErr}
          />
        </div>
      </div>
    );
  }
}
